/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { retrieveServiceManualsEndPoint, getServiceManualDetailEndPoint } from '../common/constants';
import { sendRequestAndReceiveResponse, filterNames, filterModels } from '../common/common';

const UPDATE_SELECTED_FAMILY = 'UPDATE_SELECTED_FAMILY';
const UPDATE_SELECTED_PRODUCTNAME = 'UPDATE_SELECTED_PRODUCTNAME';
const UPDATE_SELECTED_PRODUCTMODEL = 'UPDATE_SELECTED_PRODUCTMODEL';
const SERVICE_MANUAL_DATA = 'SERVICE_MANUAL_DATA';
const LOADING_MANUAL_DETAIL = 'LOADING_MANUAL_DETAIL';
const SERVICE_MANUAL_DETAIL = 'SERVICE_MANUAL_DETAIL';
const UPDATE_ALL_CLASSIFICATION = 'UPDATE_ALL_CLASSIFICATION';
const UPDATE_FAMILIES = 'UPDATE_FAMILIES';
const UPDATE_PRODUCTNAMES = 'UPDATE_PRODUCTNAMES';
const UPDATE_PRODUCTMODELS = 'UPDATE_PRODUCTMODELS';
const LOAD_SERVICE_MANUAL = 'LOAD_SERVICE_MANUAL';
const UPDATE_SERIAL_NUMBER = 'UPDATE_SERIAL_NUMBER';
const STOP_LOADING = 'STOP_LOADING';
const CLEAR_VIEW_MANUAL_STORE = 'CLEAR_VIEW_MANUAL_STORE';
const CLEAR_MANUAL_LIST = 'CLEAR_MANUAL_LIST';

const initialState = {
    data: {},
    families: [],
    productNames: [],
    productModels: [],
    serialNumber: ''
}

export const actionCreators = {
    UpdateSelectedFamily: (selectedFamilies: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_SELECTED_FAMILY, selectedFamilies });
        const serviceManualData = await sendRequestAndReceiveResponse(
            JSON.stringify({
                'ClassificationId': selectedFamilies[0],
                'ClassificationType': 'productfamily'
            }), retrieveServiceManualsEndPoint);
        dispatch({ type: SERVICE_MANUAL_DATA, serviceManualData });
    },
    UpdateSelectedProductName: (SelectedProductNames: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_SELECTED_PRODUCTNAME, SelectedProductNames });
        const serviceManualData = await sendRequestAndReceiveResponse(
            JSON.stringify({
                'ClassificationId': SelectedProductNames[0],
                'ClassificationType': 'productname'
            }), retrieveServiceManualsEndPoint);
        dispatch({ type: SERVICE_MANUAL_DATA, serviceManualData });
    },
    UpdateSelectedProductModel: (SelectedProductModels: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_SELECTED_PRODUCTMODEL, SelectedProductModels });
        const serviceManualData = await sendRequestAndReceiveResponse(
            JSON.stringify({
                'ClassificationId': SelectedProductModels[0],
                'ClassificationType': 'productmodel'
            }), retrieveServiceManualsEndPoint);
        dispatch({ type: SERVICE_MANUAL_DATA, serviceManualData });
    },
    selectManual: (data: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: LOADING_MANUAL_DETAIL });
        const selectedManual = await sendRequestAndReceiveResponse(
            JSON.stringify({
                'ServiceManualId': data.serviceManualId
            }), getServiceManualDetailEndPoint);
        dispatch({ type: SERVICE_MANUAL_DETAIL, selectedManual });
    },
    UpdateProductClassificationonSerialNumber: (selectedFamily: any, selectedProductName: any, selectedProductModel: any, serviceManualData: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_ALL_CLASSIFICATION, selectedFamily, selectedProductName, selectedProductModel, serviceManualData });
    },
    FilterNames: (Productfamilies: any, selectedProductFamily: any,) => async (dispatch: any, getState: any) => {

        let productNames: any = [];

        productNames = filterNames(Productfamilies, selectedProductFamily);

        dispatch({ type: UPDATE_PRODUCTNAMES, productNames });

    },
    FilterModels: (ProductNames: any, selectedProductName: any,) => async (dispatch: any, getState: any) => {

        let productModels: any = [];
        productModels = filterModels(ProductNames, selectedProductName);
        dispatch({ type: UPDATE_PRODUCTMODELS, productModels });

    },
    UpdateProductFamilies: (families: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_FAMILIES, families });

    },
    LoadServiceManual: (serialNumber: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: LOAD_SERVICE_MANUAL, serialNumber });
    },
    UpdateSerialNumber: (serialNumber: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_SERIAL_NUMBER, serialNumber });
    },
    StopLoading: () => async (dispatch: any, getState: any) => {
        dispatch({ type: STOP_LOADING });
    },
    ClearViewManualData: () => async (dispatch: any, getState: any) => {
        dispatch({ type: CLEAR_VIEW_MANUAL_STORE });
    },
    ClearManualList: () => async (dispatch: any, getState: any) => {
        dispatch({ type: CLEAR_MANUAL_LIST });
    }
}

export const reducer = (state: any, action: any) => {
    state = state || initialState;

    switch (action.type) {
        case UPDATE_SELECTED_FAMILY:
            return {
                ...state,
                selectedFamily: action.selectedFamilies,
                selectedProductName: undefined,
                selectedProductModel: undefined,
                isManualLoading: true,
                selectedManual: undefined,
                serialNumber: ''
            };
        case UPDATE_SELECTED_PRODUCTNAME:
            return {
                ...state,
                selectedProductName: action.SelectedProductNames,
                selectedProductModel: undefined,
                isManualLoading: true,
                selectedManual: undefined,
                serialNumber: ''
            };
        case UPDATE_SELECTED_PRODUCTMODEL:
            return {
                ...state,
                selectedProductModel: action.SelectedProductModels,
                isManualLoading: true,
                selectedManual: undefined,
                serialNumber: ''
            };
        case SERVICE_MANUAL_DATA:
            return {
                ...state,
                serviceManualData: action.serviceManualData,
                isManualLoading: false,
            };
        case LOADING_MANUAL_DETAIL:
            return {
                ...state,
                loadingManualDetail: true
            };
        case SERVICE_MANUAL_DETAIL:
            return {
                ...state,
                loadingManualDetail: false,
                selectedManual: action.selectedManual
            };
        case UPDATE_ALL_CLASSIFICATION:
            return {
                ...state,
                selectedFamily: action.selectedFamily,
                selectedProductName: action.selectedProductName,
                selectedProductModel: action.selectedProductModel,
                serviceManualData: action.serviceManualData,
                isManualLoading: false,
            };
        case UPDATE_FAMILIES:
            return {
                ...state,
                families: action.families
            };
        case UPDATE_PRODUCTNAMES:
            return {
                ...state,
                productNames: action.productNames
            };
        case UPDATE_PRODUCTMODELS:
            return {
                ...state,
                productModels: action.productModels
            };
        case LOAD_SERVICE_MANUAL:
            return {
                ...state,
                isManualLoading: true,
                serialNumber: action.serialNumber,
                selectedFamily: undefined,
                selectedProductName: undefined,
                selectedProductModel: undefined,
                selectedManual: undefined
            };
        case UPDATE_SERIAL_NUMBER:
            return {
                ...state,
                serialNumber: action.serialNumber
            };
        case STOP_LOADING:
            return {
                ...state,
                isManualLoading: false
            };
        case CLEAR_VIEW_MANUAL_STORE: {
            return initialState;
        }
        case CLEAR_MANUAL_LIST:
            return {
                ...state,
                serviceManualData: undefined,
            };
    }
    return state;
};
